/**
 * /app/flows — NOT a merchant product surface.
 *
 * Flow Engine is infrastructure behind Bundles (and future named products:
 * Cotización, Reserva, Checkout). Merchants use /app/bundles.
 *
 * Legacy bookmarks redirect here → Bundles. Do not restore a Flow Engine
 * inventory UI in the tenant menu.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/flows")({
  beforeLoad: () => {
    throw redirect({ to: "/app/bundles", replace: true });
  },
});
